import { useState, useRef, useEffect } from "react";
import QRCode from "qrcode";
import { Helmet } from 'react-helmet';
// import SchemaMarkupComponent from "../components/SchemaMarkupComponent.jsx";

export default function QRCodeGenerator() {
    const [link, setLink] = useState("");
    const [size, setSize] = useState(256);
    const [generated, setGenerated] = useState(false);
    const canvasRef = useRef(null);

    useEffect(() => {
        QRCode.toCanvas(canvasRef.current, "https://example.com", { width: size });
    }, [size]);

    const formatUrl = (url) => {
        if (!/^https?:\/\//i.test(url)) {
            return "https://" + url;
        }
        return url;
    };

    const handleGenerate = async () => {
        if (!link.trim()) return;

        try {
            await QRCode.toCanvas(canvasRef.current, formatUrl(link), { width: size });
            setGenerated(true);
            setLink("");
        } catch (err) {
            console.error(err);
        }
    };

    const handleDownload = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        const qrImage = canvas.toDataURL("image/png");

        const newCanvas = document.createElement("canvas");
        const newCtx = newCanvas.getContext("2d");

        newCanvas.width = canvas.width;
        newCanvas.height = canvas.height + 40;

        newCtx.fillStyle = "#ffffff";
        newCtx.fillRect(0, 0, newCanvas.width, newCanvas.height);

        const img = new Image();
        img.src = qrImage;
        img.onload = () => {
            newCtx.drawImage(img, 0, 0);

            newCtx.fillStyle = "#0c0069ff";
            newCtx.font = "18px Arial";
            newCtx.textAlign = "center";
            newCtx.fillText("Made by techecosolution.in", newCanvas.width / 2, newCanvas.height - 12);

            const pngUrl = newCanvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.href = pngUrl;
            link.download = "TES-qrcode.png";
            link.click();
        };
    };

  
    // const handleDownload = () => {
    //     const canvas = canvasRef.current;
    //     const pngUrl = canvas.toDataURL("image/png");
    //     const link = document.createElement("a");
    //     link.href = pngUrl;
    //     link.download = "qrcode.png";
    //     link.click();
    // };

    return (
        <>
            <Helmet>
                <title>Free QR Code Generator | Techecosolution</title>
                <link rel="canonical" href="https://techecosolution.in/qr-code-generator-tes" />
                <meta
                name="description"
                content="Generate free QR codes instantly for your website links with our secure and fast QR Code Generator. Download high-quality QR codes in one click."
                />
                <meta
                name="keywords"
                content="QR for instagram, QR for facebook, QR for twitter, QR for linkedin, QR code generator, free qr code, qr code for website, qr code download, techecosolution qr, qr code maker, online qr code generator, create qr code, qr code tool, qr code generator free, website qr code, qr code generator online, qr code creator, generate qr code, qr code generator for website"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph */}
                <meta property="og:title" content="Free Website QR Code Generator | Techecosolution" />
                <meta property="og:description" content="Generate free QR codes instantly for your website links with our secure and fast QR Code Generator." />
                <meta property="og:image" content="https://techecosolution.in/assets/qr-preview.png" />
                <meta property="og:url" content="https://techecosolution.in/qr-code-generator-tes" />
                <meta property="og:type" content="website" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Free Website QR Code Generator | Techecosolution" />
                <meta name="twitter:description" content="Generate free QR codes instantly for your website links with our secure and fast QR Code Generator." />
                <meta name="twitter:image" content="https://techecosolution.in/assets/qr-preview.png" />
            </Helmet>
            
            <div className="max-w-lg mx-auto p-6">
                <h1 className="text-2xl text-white font-bold mt-28 text-center">QR Code Generator</h1>
                <input
                    type="text"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                    placeholder="Paste website link (e.g. google.com)"
                    className="w-full border border-gray-400 rounded-lg p-3 mb-4 mt-6 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <button
                    onClick={handleGenerate}
                    className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-center block mx-auto"
                >
                    Generate QR Code
                </button>
                <div className="mt-6 flex justify-center">
                    <canvas
                        ref={canvasRef}
                        className={`transition-all duration-500 ${
                            generated ? "blur-0" : "blur-sm"
                        }`}
                    />
                </div>
                {generated && (
                    <button
                        onClick={handleDownload}
                            className="mt-4 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 block mx-auto"
                        >
                            Download QR Code
                    </button>
                )}
            </div>
        </>
    );
}
